import React, { useEffect } from 'react';
import { BusinessHeader, Header, BusinessSettingsInfo } from 'widgets';
import { businessStore } from 'entities/index';
import { Loading } from 'pages/loading/ui/loading.page';
import { observer } from 'mobx-react';
import { PageLayout } from 'shared/ui';

export const BusinessSettingsPage: React.FC = observer(() => {
  const businessId = businessStore.businessId;

  useEffect(() => {
    if (businessId && !businessStore.businessHeaderData) {
      businessStore.initBusinessHeaderData(businessId);
    }
  }, []);

  return businessStore.businessHeaderData ? (
    <PageLayout>
      <Header />
      <BusinessHeader isSettings={false} />
      <BusinessSettingsInfo />
    </PageLayout>
  ) : (
    <Loading />
  );
});
